import React from 'react';
// import { Link } from 'gatsby';
import Layout from '../layout';
import {
  GeneralPageContainer,
  PrivacyPolicy,
  PrivacyPolicyContent,
} from '../components/StyledComponents';
import messages from '../i18n/en';

class IndexPage extends React.PureComponent<any, any> {
  handleFormState = (value: boolean) => {
    this.setState({ formFilled: value });
  };

  public render() {
    return (
      <Layout
        messages={messages}
        location={this.props.location}
        className="first-page"
        title={`Esper Terms of Service`}
        keywords={`Terms of Service`}
        description={`Complete Terms of Service for the Esper website and mobile application, and info on how to get in touch with Esper. `}
      >
        <GeneralPageContainer>
          <PrivacyPolicy> Terms of Service </PrivacyPolicy>
        </GeneralPageContainer>
        <PrivacyPolicyContent>
          <p>
            <span>
              <strong>General</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              This website &lsquo;www.esper.io&rsquo; (from now on referred to
              as &ldquo;Website&rdquo;), and the mobile application
              &lsquo;Esper&rsquo; is owned by Esper Enterprises Inc., operating
              in the name and style of Esper. Please read the Terms of Service
              carefully before accessing or using our services. You can review
              the most current version of the Terms of Service at any time on
              this page.
            </span>
          </p>
          <br />
          <p>
            <span>
              These Terms of Service including with any extension, annex, and
              update, together with the Privacy Policy govern the way you will
              use our mobile application, our connected hardware, and, all
              related services including all information, tools, and services
              (&ldquo;Services&rdquo;). By accessing or using any part of the
              Services, you agree to be bound by this Agreement, Privacy Policy
              as well as rules, guidelines, policies, terms, and conditions
              applicable to any service/module that is provided (collectively
              &ldquo;Terms&rdquo;). If you do not agree to all the Terms, you
              may not access or use our Services. We reserve the right to
              update, change or replace any part of these Terms by posting
              updates and/or changes. Your continued use of or access to the
              Services following the posting of any changes constitutes
              acceptance of those changes.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Terms</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              For the purposes of these Terms, as amended, wherever the context
              so requires &ldquo;You&rdquo; or &ldquo;User&rdquo; shall mean any
              natural or legal person who accesses this Website or has agreed to
              become a user of the services provided by Esper.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;Agreement&rdquo; shall mean and refer to Terms, including
              any amendments that may be incorporated into it.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;Intellectual Property Rights&rdquo; shall mean all
              intellectual property rights and all analogous rights subsisting
              under the laws of each and every jurisdiction throughout the world
              and intellectual property of the rights concerned including all
              extensions and renewals of such rights, whether or not such rights
              are registered or capable of registration, including, without
              limitation, copyrights, trademarks, trade names, service marks,
              service names, patents, designs and all other proprietary rights
              of whatsoever description whether or not protected and whether or
              not capable of protection.
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;Malicious Code&rdquo; shall mean code, files, scripts, or
              programs intended to do harm, including, for example, viruses,
              worms, time bombs and Trojan horses. Additionally, any file,
              script, program, a browser plug-in, browser helper or extension,
              or any robot or application designed to scrape and collect data or
              automate the entry of data shall also be deemed Malicious Code.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;Application&rdquo; shall mean and refer to EsperOS, the
              modular and secure OS built on Android Open source, and any
              version of the software being made available through the Website
              and the Mobile Application.
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;Third-Party&rdquo; shall mean and refer to any natural or
              legal persons apart from the User and Esper.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              {' '}
              &ldquo;Use&rdquo; shall mean directly or indirectly activating the
              processing capabilities of the Software, to load, execute access,
              employ the Software, or display information resulting from such
              capabilities, including but not limited to employing the
              proprietary information made available as part of the Services.
            </span>
          </p>
          <br />
          <p>
            <span>
              &ldquo;We&rdquo;, &ldquo;us&rdquo;, &ldquo;Our&rdquo; shall mean
              Esper Enterprises Inc.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Limited License</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              Subject to Terms, the user is hereby granted a limited,
              non-exclusive, non-transferable, non-sublicensable, license to use
              the Services and other proprietary information. Esper
              (&ldquo;Licensor&rdquo;) may modify the Terms at any time. Your
              continued use of the Services and/or data derived there from shall
              constitute your acceptance of such revised Terms.
            </span>
          </p>
          <br />
          <p>
            <span>
              The Licensor may at any time assign, transfer or novate all or any
              part of the Terms (including its rights and obligations) to any
              other person without the consent of the licensee.
            </span>
          </p>
          <br />
          <p>
            <span>
              The licensee acknowledges the proprietary nature of the
              application, it's architecture, logic, data sources, and
              processes, and shall do everything within its control to protect
              its confidentiality.
            </span>
          </p>
          <br />
          <p>
            <span>
              Licensee shall not have the right to change, alter, copy, amend,
              reverse engineer, decompile, disassemble, publish, disclose,
              display or make available, in whole or in part, or otherwise use
              the software in any manner whatsoever, except as specified herein.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              Esper, its affiliates, and its licensors, shall retain all right,
              title, know-how, and other proprietary and intellectual property
              rights in the Application. The Licensee does not acquire any
              rights in the Software, except as specified and granted in this
              Agreement, and shall not remove any proprietary, copyright,
              patent, trademark, design right, trade secret or any other
              proprietary rights legends from the Software.
            </span>
          </p>
          <br />
          <p>
            <span>
              The Licensee shall not modify, resell, distribute, or create
              derivative works based on the software or any part thereof.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <br />
          <p>
            <span>
              <strong>Rights in the mobile Application</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              Subject to your compliance with these Terms, Esper grants you a
              limited non-exclusive, non-transferable, non-sublicensable license
              to download and install a copy of the Application on a mobile
              device or computer that you own or control and to run such copy of
              the Application solely for your own commercial purposes. You may
              not copy the Application, except for making a reasonable number of
              copies for backup or archival purposes. Except as expressly
              permitted in these Terms, you may not: (i) copy, modify, translate
              or create derivative works based on the Application; (ii)
              distribute, transfer, publish, disclose, sublicense, lease, lend,
              sell or rent the Application to any third party; (iii) reverse
              engineer, decompile, reverse decompile or disassemble the
              Application, or otherwise attempt to derive the source code; (iv)
              make the functionality of the App available to third parties or
              multiple users through any means, or (v) benchmark or conduct any
              performance or comparison tests on the Application.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Reservation of Rights</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              No other rights are granted except as expressly set forth in the
              Terms. We own all right, title, and interest, including all
              intellectual property rights, in and to the Services and the
              underlying software and any and all updates, upgrades,
              modifications, enhancements, content, improvements or derivative
              works thereof, and in any idea, know-how, and programs developed
              by us or our licensors during the course of performance of the
              Services.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Restrictions on Use</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              In the event you are barred from undertaking legally binding
              obligations as per the laws of your region, or are for any reason,
              unable to provide &lsquo;consent&rsquo;, you are not eligible to
              register for, use or avail the Services.
            </span>
          </p>
          <br />
          <p>
            <span>
              Without limiting any other provisions of these Terms, you may not
              use this Application for any purpose that is unlawful or
              prohibited by these Terms and/or any applicable additional terms.
              Your access of this Application may be terminated immediately, in
              our sole discretion, with or without notice, if you fail to comply
              with any provision of these Terms and/or additional terms, or for
              any other or no reason. You may access your account from only one
              platform at a time and up to three devices altogether.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              <br />
              <strong>Registration</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              During registration, You agree to (a) provide true, accurate,
              current and complete information about yourself as prompted by the
              registration form, (b) maintain and promptly update your data to
              keep it true, accurate, current and complete; and (c) comply with
              the Terms. If you provide any information that is untrue,
              inaccurate, not current or incomplete, or if we believe that such
              information is untrue, inaccurate, not current or incomplete, we
              reserve the right to suspend or terminate your account and refuse
              any and all current or future access to the Services, or any
              portion thereof.
            </span>
          </p>
          <br />
          <p>
            <span>
              You retain sole responsibility for maintaining the confidentiality
              of your account, username and password and for all activities and
              liabilities associated with or occurring under your account. You
              must notify us immediately of any unauthorized use of your
              account, username or password and any other breach of security,
              and ensure that you exit from your account at the end of each
              session. We cannot and will not be responsible for any loss or
              damage arising from your failure to comply with this requirement
              or as a result of (mis)use of your account, username or password,
              by a third party, with your knowledge or otherwise. However, you
              could be held liable for losses incurred by us or another party
              due to someone else using your account, username or password.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Users</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              The Enterprise Admin may designate and authorize users with
              limited access to the Services. You (i) are responsible for Your
              Authorized Users&rsquo; compliance with the Agreement, and (ii)
              shall use commercially reasonable efforts to prevent unauthorized
              access to or use of the Services and shall notify us immediately
              of any such unauthorized access or use. It is your responsibility
              to remove access to the Services if authorized status of a User or
              designated employee changes.
            </span>
          </p>
          <br />
          <p>
            <span>
              You shall not transfer your account to another person, and you may
              not use anyone else&rsquo;s account, at any time without the
              permission of the account holder.{' '}
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Features</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              Esper Services include but are not limited to: Provision/enrol a
              device (create and scan a QR code to provision a device as per
              policy selected) under an enterprise; Device Management (add, view
              device data and information such as storage, memory, battery and
              location, perform actions such as ping, wipe, reboot and lock,
              manage group, apps, policy, see status and take remote control and
              screenshot); Group Management (add/remove devices from groups,
              add/remove groups); Policy Management (create, edit, remove
              policy, provision devices, change policy related settings); App
              Management (upload and manage apps); Enterprise Configuration
              (create and edit company profiles); User Management (create and
              edit user profiles); and, Approve and install Playstore apps and
              setup and configure Alerts based on device parameters.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Communications</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              By using our Services, it is deemed that you have consented to
              receiving communications through, without limitation, telephonic
              calls, SMSs and/or emails. Such communications shall be sent to
              you on the telephone number and/or email id provided by you for
              the use of Esper Services. Such communication may be for purposes
              that inter alia include clarification calls, marketing calls and
              promotional calls.{' '}
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>User Content</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              Any information/content that you post or otherwise make available
              on or through the website or the mobile Application, is
              &ldquo;User Generated Content&rdquo;.
              <span className="Apple-converted-space">&nbsp; </span>You retain
              all rights in, and are solely responsible for, all User Generated
              Content, subject to the terms set forth herein.
            </span>
          </p>
          <br />
          <p>
            <span>
              You shall: (i) have sole responsibility for the accuracy, quality,
              integrity, legality, reliability, and appropriateness of all data
              and content that You may submit for accessing/using the Services;
              (ii) use commercially reasonable efforts to prevent unauthorized
              control or tampering or any other unauthorized access to, or use
              of, the Services and notify us promptly of any unauthorized use or
              security breach; and (iii) comply with all applicable local,
              state, central, and foreign laws (including laws regarding privacy
              and protection of personal or consumer information) in providing
              the User Generated Content.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Our use of User Generated Content</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              You grant Esper, its affiliates and concerns, a non-exclusive,
              royalty-free, transferable, sub-licensable, worldwide license to
              store, display, reproduce, and distribute your User Generated
              Content for the purposes of operating, developing, providing Esper
              Services. Nothing in these Terms shall restrict other legal rights
              Esper may have to User Generated Content under other licenses. We
              reserve the right to remove User Generated Content for any reason,
              including a violation or an apparent violation of the Terms, as we
              may solely determine. However, we do not retain the right to
              modify any User Generated Content, and shall not access the User
              Generated Content, in the event such access is not required for
              the purposes of providing Services.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Our Use of Anonymous Data. </strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              You agree that Esper may use the data generated by and stored on
              our servers, anonymously, for our own internal business purposes,
              including but not limited to the development of anonymous
              marketing and sales collateral materials, statistical analysis of
              data, and publication solely in an aggregated form of operating
              data in industry benchmark reports. You shall at all times retain
              ownership of Your data.
            </span>
          </p>
          <br />
          <p>
            <span>
              Following termination or deactivation of your account, or your
              removal of any User Generated Content from Esper, we may, but
              shall not be bound to, retain such content for a commercially
              reasonable period of time for backup, archival, or audit purposes.
              It is specified that Esper shall have the right to remove all User
              Generated Content following termination or deactivation of your
              account.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              <br />
              <strong>Intellectual Property Rights</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              All information, content, and data displayed on, transmitted
              through, or used in connection with the Services, including for
              example text, photographs, images, illustrations, audio clips,
              video, html, source and object code, trademarks, logos, and the
              like (collectively and hereinafter referred to as the
              &ldquo;Content&rdquo;), as well as its selection and arrangement,
              is owned or licensed by Esper. You may access the Content solely
              through the Services, and in accordance with the Terms.
            </span>
          </p>
          <br />
          <p>
            <span>
              You may not republish any portion of the Content on any internet,
              intranet or extranet website or incorporate the Content in any
              database, compilation, archive or cache. You may not distribute
              any Content to others, whether or not for payment or other
              consideration, and you may not modify, copy, frame, cache,
              reproduce, sell, publish, transmit, display or otherwise use any
              portion of the Content. You may not scrape or otherwise copy the
              Content without permission. You agree not to decompile, reverse
              engineer or disassemble any software or other products or
              processes accessible through the Application; not to insert any
              code or product or manipulate the content of the Application in
              any way that affects the user's experience, and not to use any
              data mining, data gathering or extraction method.{' '}
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>
                User&rsquo;s Obligations / Representations and Warranties
              </strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              You are responsible for all activities relating to your use of the
              Services as well as the use of Services by
              <span className="Apple-converted-space">&nbsp; </span>your
              authorised Users.
            </span>
          </p>
          <br />
          <p>
            <span>
              The User undertakes to fulfil the following obligations, the
              failure to satisfy any of which gives us the right to permanently
              suspend your account and/or claim damages for any losses that
              accrue to us or additional costs that may be imposed on us or
              incurred by us.
            </span>
          </p>
          <br />
          <p>
            <span>
              You may not, and you shall ensure your authorized users do not,
            </span>
          </p>
          <br />
          <p>
            <span>
              (a) Cut, copy, recreate, reverse engineer, or create derivative
              works from, transfer, or sell the Content.{' '}
            </span>
          </p>
          <p>
            <span>
              (b) Access (or attempt to access) the Services and/or the
              materials on any network by any means other than through the
              interface that is provided by the Services. The use of deep-link,
              robot, spider or other automatic device, program, algorithm or
              methodology, or any similar or equivalent manual process, to
              access, acquire, copy or monitor any portion of the mobile
              Application/Content/Services, or in any way reproduce or
              circumvent the navigational structure or presentation of the
              website/mobile Application, materials or any Content, to obtain or
              attempt to obtain any materials, documents or information through
              any means not specifically made available through the Services is
              prohibited.{' '}
            </span>
          </p>
          <p>
            <span>
              (c) use the Services in any manner that may impair, overburden,
              damage, disable or otherwise compromise Esper&rsquo;s servers.
            </span>
          </p>
          <p>
            <span>
              (d) use the modules, features, or information made available
              through the Services to further any unlawful purposes or to
              conduct any unlawful activity, including, but not limited to,
              fraud, embezzlement, money laundering or identity theft.
            </span>
          </p>
          <p>
            <span>
              (e) use the modules, features, or information made available
              through the Services to abuse, harass, threaten, defame,
              disillusion, erode, abrogate, demean or otherwise violate the
              legal rights of others;
            </span>
          </p>
          <p>
            <span>
              (f) engage in any activity that interferes with or disrupts access
              to the Services (or the servers and networks which are connected
              to the Services);
            </span>
          </p>
          <p>
            <span>
              (g) probe, scan or test the vulnerability of the Services or any
              network connected thereto, nor breach the security or
              authentication measures on the website/mobile Application or any
              network connected thereto. You may not reverse look-up, trace or
              seek to trace any information on any other user of the Services,
              or exploit the Services or information made available or offered
              by or through the Services, in any way whether or not the purpose
              is to reveal any information, including but not limited to
              personal identification information, other than your own
              information, as required;
            </span>
          </p>
          <p>
            <span>
              (h) disrupt or interfere with the security of, or otherwise cause
              harm to, the Services, systems resources, servers or networks
              connected to or accessible through the Services or any affiliated
              or linked applications;
            </span>
          </p>
          <p>
            <span>
              (i) violate any applicable laws or regulations for the time being
              in force within or outside the United States of America;
            </span>
          </p>
          <p>
            <span>
              (j) license, sublicense, sell, rent, assign, distribute, time
              share transfer, lease, loan, resell, distribute or otherwise
              commercially exploit, grant rights in or make the Services
              available to any third party;{' '}
            </span>
          </p>
          <p>
            <span>
              (k) violate any code of conduct or other guidelines, which may be
              applicable for or to any particular Service; or
            </span>
          </p>
          <p>
            <span>
              (l) use the Services to transmit infringing, libellous, obscene,
              threatening, or otherwise unlawful, unsafe, or abusive material,
              or to store or transmit material in violation of third-party
              privacy rights.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              YOU EXPRESSLY UNDERSTAND AND AGREE THAT, TO THE MAXIMUM EXTENT
              PERMITTED BY APPLICABLE LAW:
            </span>
          </p>
          <br />
          <p>
            <span>
              We do not guarantee, represent or warrant that your use/access of
              Services will be uninterrupted, timely, secure or error-free. We
              do not warrant that the results that may be obtained from the use
              of the Services will be accurate or reliable. You agree that from
              time to time we may remove the Services for indefinite periods of
              time or limit access to the Services at any time, without notice
              to you. You expressly agree that your use of, or inability to use,
              the Services is at your sole risk.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              The Services are provided 'as is' and 'as available' for your use,
              without any representation, warranty or condition of any kind,
              either express or implied, including all implied warranties or
              conditions of merchantability, merchantable quality, fitness for a
              particular purpose, durability, title, and non-infringement.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              In no event shall our directors, officers, employees, affiliates,
              agents, contractors, suppliers, service providers or licensors be
              liable for any injury, loss, claim, or any direct, indirect,
              incidental, punitive, special, or consequential damages of any
              kind, including, without limitation lost profits, lost revenue,
              lost savings, loss of data, replacement costs, or any similar
              damages, whether based in contract, tort (including negligence),
              strict liability or otherwise, arising from your use of any the
              Services, or for any other claim related in any way to your use of
              the Services, including, but not limited to, any errors or
              omissions in any Content, or any loss or damage of any kind
              incurred as a result of the use of the Services or any Content
              posted, transmitted, or otherwise made available, even if we have
              been advised of such possibility.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              You agree to indemnify, defend and hold harmless Esper and our
              subsidiaries, affiliates, partners, officers, directors, agents,
              contractors, licensors, service providers, subcontractors,
              suppliers, interns and employees, harmless from any claim or
              demand, including reasonable attorneys&rsquo; fees, made by any
              third-party due to or arising out of your access to the Services,
              breach of the Terms, or the documents they incorporate by
              reference, or your violation of any law or the rights of a
              third-party.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Termination</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              The obligations and liabilities of the parties incurred prior to
              the termination date shall survive the termination of this
              Agreement for all purposes. The Terms are effective unless and
              until terminated by either you or us. You may terminate these
              Terms at any time by notifying us that you no longer wish to use
              our Services. If in our sole judgment you fail, or we suspect that
              you have failed, to comply with any term or provision of these
              Terms, we also may terminate this agreement at any time without
              notice and you will remain liable for all amounts due up to and
              including the date of termination; and/or accordingly may deny you
              access to our Services (or any part thereof).
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Jurisdiction</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              This agreement is governed and construed in accordance with the
              Laws of the State of California. You hereby irrevocably consent to
              the exclusive jurisdiction and venue of the US District Court for
              the Northern District of California, United States of America in
              all disputes arising out of or relating to the use of Esper
              Services.{' '}
            </span>
          </p>
          <br />
          <p>
            <span>
              Use of Services is unauthorized in any jurisdiction that does not
              give effect to all provisions of these terms and conditions,
              including without limitation this paragraph.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Entire Agreement</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              The failure by Esper to exercise or enforce any right or provision
              of these Terms shall not constitute a waiver of such right or
              provision. The Terms constitute the entire agreement and
              understanding between you and Esper and govern your use of the
              Services, superseding any prior or contemporaneous agreements,
              communications and proposals, whether oral or written, between you
              and Esper (including, but not limited to, any prior versions of
              the Terms). Any ambiguities in the interpretation of these Terms
              shall not be construed against the drafting party.
            </span>
          </p>
          <br />
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Contact Information</strong>
            </span>
          </p>
          <br />
          <p>
            <span>
              Questions about the Terms should be sent to{' '}
              <a href="mailto:partner@esper.io">
                <span className="s3">partner@esper.io.</span>
              </a>
            </span>
          </p>
        </PrivacyPolicyContent>
      </Layout>
    );
  }
}

export default IndexPage;
